import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  createInstrumentListGroup,
  deleteInstrumentListGroup,
  getInstrumentListGroup,
  getInstrumentListGroups,
  getInstrumentListGroupsMasterData,
  updateInstrumentListGroup
} from '../../../api/instrument-list-groups';

export const getInstrumentListGroupsAsync = createAsyncThunk(
  'instrumentListGroups/getInstrumentListGroups',
  getInstrumentListGroups
);

export const getInstrumentListGroupsMasterDataAsync = createAsyncThunk(
  'instrumentListGroups/getInstrumentListGroupsMasterData',
  getInstrumentListGroupsMasterData
);

export const getInstrumentListGroupAsync = createAsyncThunk(
  'instrumentListGroups/getInstrumentListGroup',
  getInstrumentListGroup
);

export const createInstrumentListGroupAsync = createAsyncThunk(
  'instrumentListGroups/createInstrumentListGroup',
  createInstrumentListGroup
);

export const updateInstrumentListGroupAsync = createAsyncThunk(
  'instrumentListGroups/updateInstrumentListGroup',
  updateInstrumentListGroup
);

export const deleteInstrumentListGroupAsync = createAsyncThunk(
  'instrumentListGroups/deleteInstrumentListGroup',
  deleteInstrumentListGroup
);

export interface InstrumentListGroup {
  id: number;
  name: string;
  instrumentLists: {
    id: number;
    name: string;
  }[];
}

interface InstrumentListGroupState {
  data: InstrumentListGroup[];
  masterData: InstrumentListGroup[];
  count: number;
  selectedInstrumentListGroup: InstrumentListGroup | null;
}

const initialState: InstrumentListGroupState = {
  data: [],
  masterData: [],
  count: 0,
  selectedInstrumentListGroup: null
};

export default createSlice({
  name: 'instrumentListGroups',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getInstrumentListGroupsAsync.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });
    builder.addCase(
      getInstrumentListGroupsMasterDataAsync.fulfilled,
      (state, action) => {
        state.masterData = action.payload.data;
        state.count = action.payload.count;
      }
    );
    builder.addCase(getInstrumentListGroupAsync.fulfilled, (state, action) => {
      state.selectedInstrumentListGroup = action.payload;
    });
  }
});
